import { Injectable, inject } from '@angular/core';
import { QueryOptions } from 'odata-query';
import { first, map, Observable, shareReplay } from 'rxjs';
import {
  CountryResponseWithNestedObjects,
  CountryResponseWithNestedObjectsODataWithMetadataResponse,
  GstarClient,
} from '../../../web-api-client';
import { mapCountryFromResponse } from '../mappers';
import { Collection, Country } from '../models';

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  private gstarClient = inject(GstarClient);

  private cache$!: Observable<Collection<Country>> | null;

  get(query?: Partial<QueryOptions<Country>>): Observable<Country[]> {
    if (!this.cache$) {
      this.cache$ = this.gstarClient
        .countriesGET(
          undefined,
          undefined,
          query?.top?.toString(),
          query?.skip?.toString(),
          query?.orderBy?.toString(),
          query?.count?.toString(),
          undefined
        )
        .pipe(
          map(response => ({
            total: response.odataCount ?? 0,
            items:
              response.value?.map(responseEntity =>
                mapCountryFromResponse(responseEntity)
              ) ?? [],
          })),
          shareReplay(1)
        );
    }

    return this.cache$.pipe(
      first(),
      map((response: Collection<Country>): Country[] => response.items)
    );
  }

  getCountryByCode(code: string): Observable<Country | undefined> {
    return this.gstarClient
      .countriesGET(
        undefined,
        `code eq '${code}'`,
        '1',
        undefined,
        undefined,
        undefined,
        undefined
      )
      .pipe(
        map(
          (
            responseEntity: CountryResponseWithNestedObjectsODataWithMetadataResponse
          ) => {
            if (responseEntity.value?.length === 1)
              return mapCountryFromResponse(responseEntity.value[0]);
            return undefined;
          }
        )
      );
  }

  getCountryById(countryId: number): Observable<Country | undefined> {
    return this.gstarClient.countriesGET2(countryId).pipe(
      map((responseEntity: CountryResponseWithNestedObjects) => {
        return mapCountryFromResponse(responseEntity);
      })
    );
  }
}
